module.exports = __webpack_public_path__ + "linea-basic-10.ce776cff0588d8e8385c.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/linea-icons/fonts/linea-basic-10.svg
// module id = ../../../../../src/scss/icons/linea-icons/fonts/linea-basic-10.svg
// module chunks = styles